import { Button } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { ASSETS_PATH } from "./../constants";
import { uploadAsset } from "./../utilities/assetUtils";
import CircularWithValueLabel from "./../components/CircularWithValueLabel";


const PopNarations = ({narrations={}, onSetNarrations, onNarrationsPopClose}) => {

    const [narrs, setNarrs] = useState(narrations);

    const [availableLangs, setAvailableLangs] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);



    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/language`, { method: 'GET' })
            .then((res) => res.json())
            .then((json) => {
                console.log(json);
                const ls = json.languages;
                ls.unshift({language:"English", language_slug:"english"})
                setAvailableLangs(json.languages)
            });
    }, [])

    const onUploadNarration = (e, lang) => {
        uploadAsset(e, (fileName) => { setNarrs(prev => { return { ...prev, [lang]:{...prev[lang], audio:fileName}} }) }, setUploading, setProgress)
        console.log(narrs);
    }

    const onRemoveNarration = (lang) => {
        setNarrs(prev => { return { ...prev, [lang]:{...prev[lang], audio:""}} });
    }


    const onUploadSubtitle = (e, lang) => {
        uploadAsset(e, (fileName) => { setNarrs(prev => { return { ...prev, [lang]:{...prev[lang], subtitle:fileName}} }) }, setUploading, setProgress)
        console.log(narrs);
    }

    const onRemoveSubtitle = (lang) => {
        setNarrs(prev => { return { ...prev, [lang]:{...prev[lang], subtitle:""}} });
    }

    return (
        <>
        <div className="pop-naration" id="pop-naration">
            <div className="pop-background"></div>
            <div className="pop-container">
                <div className="pop-header">
                    Upload Narations in other languages
                </div>
                <div className="pop-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    {
                        availableLangs.map((l, index) =>
                            <Fragment key={index}>
                                <br />
                                <div className="flex flex-row gap-4">
                                    <div className="w-28">{l.language}</div>
                                    {(!narrs[l.language_slug] || !narrs[l.language_slug].audio ||narrs[l.language_slug].audio.trim() === "") &&
                                        <>
                                        <Button
                                        variant="contained"
                                        component="label"
                                    >
                                        Upload Narration MP3
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(e) => onUploadNarration(e, l.language_slug)}
                                        />
                                    </Button>
                                        </>
                                    }
                                    
                                    {narrs[l.language_slug] && narrs[l.language_slug].audio &&narrs[l.language_slug].audio.trim() !== "" &&
                                        <>
                                            <audio controls>
                                                <source src={`${ASSETS_PATH}/${narrs[l.language_slug].audio}`} type="audio/mpeg" />

                                            </audio>
                                            <Button
                                                onClick={() => onRemoveNarration(l.language_slug)}
                                            >
                                                Remove Narration

                                            </Button>
                                        </>
                                    }



                                    {(!narrs[l.language_slug] || !narrs[l.language_slug].subtitle || narrs[l.language_slug].subtitle.trim() === "") &&
                                        <>
                                        <Button
                                        variant="contained"
                                        component="label"
                                    >
                                        Upload Narration Subtitle
                                        <input
                                            type="file"
                                            hidden
                                            onChange={(e) => onUploadSubtitle(e, l.language_slug)}
                                        />
                                    </Button>
                                        </>
                                    }
                                    
                                    {narrs[l.language_slug] && narrs[l.language_slug].subtitle && narrs[l.language_slug].subtitle.trim() !== "" &&
                                        <>
                                            <div>{narrs[l.language_slug].subtitle.trim()}</div>
                                            <Button
                                                onClick={() => onRemoveSubtitle(l.language_slug)}
                                            >
                                                Remove Subtitle

                                            </Button>
                                        </>
                                    }

                                </div>
                                <br />
                            </Fragment>
                        )
                    }
                </div>
                <div className="pop-footer flex flex-row">
                    <Button onClick={() => onSetNarrations(narrs)}>Update and Close</Button>
                    <Button onClick={onNarrationsPopClose}>Close</Button>
                </div>
            </div>
        </div>
        {uploading && <CircularWithValueLabel progress={progress} />}
        </>
    )
}

export default PopNarations;